<template>
<div class="loader-wrapper" :class="{ 'visible': visible }">
  <div class="spinner-border loader"  :class="{ 'loader--visible': visible }" style="" role="status">
    <span class="sr-only">Loading...</span>
  </div>
  </div>
</template>

<script>
export default {
  name: "loader",
  props: ["visible"]
};
</script>


